export default "__VITE_ASSET__h_yvf_Y9__"